import { Injectable, inject } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { BulkServiceService } from '../features/bulk-order/bulk-service.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { switchMap, take } from 'rxjs/operators'
import { CommonService } from './services/common.service'
import { ChangeCustAccountService } from '../features/user/change-cust-account/change-cust-account.service'
import { Actions, ofType } from '@ngrx/effects'
import { MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { OccCartAdapter } from '@spartacus/cart/base/occ'

@Injectable({
  providedIn: 'root',
})
export class VlmGuardClass {
  constructor(
    private authService: AuthService,
    private globalMessageService: GlobalMessageService,
    private router: Router,
    private bulkService: BulkServiceService,
    private userAccountFacade: UserAccountFacade,
    private commonService: CommonService,
    private changeCustAccountService: ChangeCustAccountService,
    private occAdapter: OccCartAdapter,
    private multiCartFacade: MultiCartFacade,
    private actions$: Actions
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.authService
      .isUserLoggedIn()
      .pipe(
        switchMap((isUserLoggedIn) => {
          if (isUserLoggedIn) {
            return this.userAccountFacade.get()
          } else {
            this.globalMessageService.add(
              { key: 'sharedComponents.accessedByLoggedinUser' },
              /* 'Page can only be accessed by logged-in user', */
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            localStorage.setItem('lastURL', state.url)
            this.router.navigate(['/login'])
            return of(undefined)
          }
        })
      )
      .subscribe((user: any) => {
        const email = user?.uid?.toLowerCase()
        const customerId = user?.orgUnit?.uid
        const salesOrg = user?.recentSalesArea?.uid
        const urlParams = ['vlmCart', 'vcBulkUpload', route.params['content']]
        const url = this.commonService.constructUrl(urlParams)
        if (email) {
          this.commonService.getData(url).subscribe((content: any) => {
            if (
              (customerId === content.customerId &&
                customerId &&
                content.customerId &&
                salesOrg === content.salesOrg &&
                salesOrg &&
                content.salesOrg) ||
              content.customerId === '' ||
              content.salesOrg === ''
            ) {
              this.sendData(email, content)
              this.uploadContent(content)
            } else {
              this.changeCustAccountService
                .updateLegalEntities(content.customerId, content.salesOrg)
                .subscribe(
                  (res) => {
                    this.occAdapter
                      .create('current')
                      .pipe(take(1))
                      .subscribe(
                        (occData) => {
                          this.multiCartFacade.loadCart({
                            userId: 'current',
                            cartId: occData.code,
                            extraData: {
                              active: true,
                            },
                          })
                          this.actions$
                            .pipe(
                              ofType(CartActions.LOAD_CART_SUCCESS),
                              take(1)
                            )
                            .subscribe((success) => {
                              window.location.reload()
                            })
                        },
                        (error) => {
                          this.globalMessageService.add(
                            error,
                            GlobalMessageType.MSG_TYPE_ERROR,
                            10000
                          )
                          window.scrollTo(0, 0)
                        }
                      )
                  },
                  (error) => {
                    this.globalMessageService.add(
                      error,
                      GlobalMessageType.MSG_TYPE_ERROR,
                      5000
                    )
                    window.scrollTo(0, 0)
                  }
                )
            }
          })
        }
      })
    return true
  }
  sendData(email, content) {
    const contentData = content.materials.reduce(
      (acc, item, index) =>
        acc +
        (item?.productCode || '1') +
        ',' +
        item.quantity +
        (item?.description ? ',' + item.description : '') +
        (index < content?.materials?.length ? '\n' : ''),
      ''
    )
    if (email === content.userId.toLowerCase()) {
      this.bulkService.setContent(contentData.trim())
      return true
    } else {
      return false
    }
  }
  uploadContent(content) {
    this.bulkService
      .getBulkCopyPasteList(content?.materials, 'current')
      .subscribe((res) => {
        this.bulkService.sendBulkOrderList(res)
        this.router.navigate(['bulk-Table'])
      })
  }
}
export const VlmGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(VlmGuardClass).canActivate(route, state)
}
